import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-6 py-3" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import PageLoader from '@/components/PageLoader.vue';
import PagePagination from '@/components/PagePagination.vue';
import StatusPill from '@/components/StatusPill.vue';

import throttle from "lodash/throttle";

import { paginatePage } from '@/helpers/PageHelper';

import Dashboard from "@/classes/Dashboard";
import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref, watch } from 'vue';
import { format } from 'date-fns'
import { formatter } from '@/helpers/NumberHelper'
import { formateTimeSlot } from "@/helpers/TimeFormatter"

/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarBookingPage',
  setup(__props) {

const router    = useRouter();
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);
const route = useRoute();
/**
 * ********************************
 * query 
 * ********************************
 */
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();
const pageNum   = ref<number>(1);
const date   = ref(route.params.date);

// Page Renderer Data
const items       = ref({
    totol: 0,
    data: []
});

const items_count = ref(0);
const query       = ref(null);

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'All',
        count: items_count.value,
        href: '/contents/packages',
        allowed: true
    }
];

// Headers
const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Patient' },
    { text: 'Patient Type' },
    { text: 'Booking Type' },
    { text: 'Branch' },
    { text: 'Company' },
    { text: 'Package' },
    // { text: 'Rider' },
    { text: 'Timeslot' },
    { text: 'Total Fee' },
    { text: 'Status' },
    { text: 'Booking Date' },
    { text: 'Created Date' },
];

const bookingTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'New', value: 'New' },
    { id: '3', label: 'Rescheduled', value: 'Rescheduled' },
];

/**
 * ********************************
 * Methods 
 * ********************************
 */
const searchData = (val: string) => {
    searchText.value = val
}

const applyFilters = (link:string) => {    
    if(link){
        pageNum.value = Number(link.replace('/?page=', ''))
    } else{
        pageNum.value = 1;
    }

    indexBookings();
}

const indexBookings = async (data:string|null = null) => {
    try {
        loader.value = true;
        
        const queryString = searchText.value ? `&keyword=${searchText.value}` : '';
        const goToPage    = `page=${pageNum.value}`;

        const response = await Dashboard.fetchDateBookings(goToPage + queryString + `&booking_date=${date.value}`);

        loader.value      = false;
        items.value       = response.data;
        items_count.value = items.value.total;
        
        query.value       = response.data.query;

    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response?.data?.message ?? 'An error occurred';
    }
};


const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}

/**
 * ********************************
 * Wathchers 
 * ********************************
 */
watch(
      searchText,
      throttle(() => {
        indexBookings(goToPage.value)
      }, 1000)
    );

onMounted(() => indexBookings(goToPage.value))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Bookings" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          search: searchText.value,
          onFetchData: searchData,
          "onUpdate:filters": indexBookings,
          modelValue: searchText.value,
          sidebarFilters: false,
          "custom-filters": activeTab.value !== 'activity_logs'
        }, null, 8, ["search", "modelValue", "custom-filters"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DataTable, {
          headers: headers,
          count: items.value?.total
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", _hoisted_3, _toDisplayString(item.patient_type != 'Soft' ? item.booking_id : item.id), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(item.patient?.first_name) + " " + _toDisplayString(item.patient?.last_name), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(item.patient_type == 'Individual' || item.patient_type == 'Soft' || item.patient_type == 'Dependent' ? item.patient_type : 'Corporate'), 1),
                _cache[0] || (_cache[0] = _createElementVNode("td", { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }, " New ", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }, " Bonifacio Global City ", -1)),
                _createElementVNode("td", _hoisted_6, [
                  (item.corporate_name)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(item.corporate_name), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ]),
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.package_name), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formateTimeSlot)(item.booking_start_time, item.booking_end_time)), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatter).format(item.total_fee)), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(StatusPill, {
                    color: getStatusColor(item.status),
                    text: item.status
                  }, null, 8, ["color", "text"])
                ]),
                _createElementVNode("td", _hoisted_11, _toDisplayString(new Date(item.booking_date).toISOString().split('T')[0]), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(new Date(item.booking_created_date ? item.booking_created_date : item.created_at).toISOString().split('T')[0]), 1),
                _createElementVNode("td", _hoisted_13, [
                  (
                                _ctx.$hasPermission('set-individual-patient-appointment-time') ||
                                _ctx.$hasPermission('update-individual-patient-appointment-time') ||
                                _ctx.$hasPermission('soft-book-dates-for-individual-patient') ||
                                _ctx.$hasPermission('update-corporate-patient') ||
                                _ctx.$hasPermission('update-participating-employees'))
                    ? (_openBlock(), _createBlock(ActionButton, {
                        key: 0,
                        "edit-btn": "",
                        onClick: ($event: any) => (_unref(router).push(`/branches/${item.branch.branch_id}/bookings/edit/${item.patient_type == 'Individual' || item.patient_type == 'Dependent' ? item.booking_id : item.patient_type == 'Corporate' ? item.corporate_booking_id : item.id}?patient_type=${ item.patient_type == 'Individual' || item.patient_type == 'Soft' || item.patient_type == 'Dependent' ? item.patient_type : 'Corporate' }`))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: applyFilters
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})